import { IUser } from '@/features/user/store/user.model';

import { TAppError, IBaseAction } from '@/store/types/base.state';

export enum GetChildrenTypes {
  GET_CHILDREN_USER = 'PROFILE.GET_CHILDREN_USER',
  GET_CHILDREN_USER_FAIL = 'PROFILE.GET_CHILDREN_USER_FAIL',
  GET_CHILDREN_USER_SUCCESS = 'PROFILE.GET_CHILDREN_USER_SUCCESS',
}

export interface IGetChildrenAction extends IBaseAction {
  type: typeof GetChildrenTypes.GET_CHILDREN_USER;
  userId: number;
}

export interface IGetChildrenSuccessAction extends IBaseAction {
  type: typeof GetChildrenTypes.GET_CHILDREN_USER_SUCCESS;
  children: IUser[];
  parentUserId: number;
  maxItems?: number;
}

export interface IGetChildrenFailAction extends IBaseAction {
  type: typeof GetChildrenTypes.GET_CHILDREN_USER_FAIL;
  userId: number;
  error: TAppError;
}

export type TGetChildrenAction = IGetChildrenAction | IGetChildrenSuccessAction | IGetChildrenFailAction;
